import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 24/36;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 36 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M35.9 12.08L31.792 1.046A1.609 1.609 0 0 0 29.722.1L9.693 7.464a1.596 1.596 0 0 0-.951 2.056l4.108 11.034a1.614 1.614 0 0 0 2.07.946l20.03-7.364a1.6 1.6 0 0 0 .95-2.056zM28.622 2.21l-6.213 8.827L11.91 8.355 28.62 2.21zM14.069 19.22l-3.563-9.57 8.252 2.109-4.69 7.461zm1.745.245l4.58-7.288 2.154.55a.808.808 0 0 0 .86-.316l1.276-1.812 8.251 2.572-17.121 6.294zm9.838-10.241l4.884-6.94 3.564 9.573-8.448-2.633zM9.313 20.714c-.143-.44-.574-.664-.962-.501L5.53 21.396c-.388.162-.586.65-.442 1.09.112.342.398.554.702.554a.67.67 0 0 0 .26-.053l2.822-1.183c.388-.162.586-.65.442-1.09zM4.988 13.453c-.16-.39-.638-.59-1.069-.446l-1.935.65c-.431.145-.651.579-.492.97.124.304.442.493.78.493a.906.906 0 0 0 .289-.047l1.935-.65c.431-.144.652-.579.492-.97zM2.832 19.255c-.148-.424-.593-.64-.993-.484l-1.334.523c-.4.157-.605.628-.457 1.052.115.33.41.534.725.534.089 0 .18-.016.267-.051l1.335-.523c.4-.157.605-.628.457-1.051z" fill={color} fillRule="nonzero" />
    </svg>
)

export default class IconFieldEmail extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
